exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{font-size:62.5%;font-family:Lato,sans-serif;color:#fff}body{font-size:14px;font-size:1.4rem}body,html{height:100%;background:#2b2d34}a{text-decoration:none;color:#f5f5f5}h1{color:#fff;font-size:12px;font-size:1.2rem;font-weight:300;letter-spacing:1.25px;letter-spacing:.125rem}", ""]);

// exports
